<google-chart
  [title]="title"
  [type]="type"
  [columns]="columnNames"
  [data]="chartData"
  [options]="options">
</google-chart>
